export default "__VITE_ASSET__C5QjMb3c__"